function nextInQueue<T extends BaseRequest>(requests: T[]): T | undefined {
  return requests.find(el => el.progress === 0 && el.error === false && el.canceled === false)
}

export default nextInQueue;
